module.exports = __webpack_public_path__ + "img/t5-9.68ec3401.svg";